import React from 'react';
import {Row, Col} from 'react-bootstrap';

export function Summaries(props) {
  const {summaries} = props;

  return (
    <Row>
      {summaries.map((summary, index) => {
        if (!index) {
          return (
            <Col sm={{span:2, offset: 1}}>
              <p className="mb-1 text-dark">{summary.label}</p>
              <p className="mb-0 font-weight-bolder font-size-lg">{summary.value}</p>
            </Col>
          );
        } else {
          return (
            <Col sm={2}>
              <p className="mb-1 text-dark">{summary.label}</p>
              <p className="mb-0 font-weight-bolder font-size-lg">{summary.value}</p>
            </Col>
          );
        }
      })}
    </Row>
  );
}
